import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=01e14436&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/usr/src/motec/components/PageHeader.vue').default,ProductCard: require('/usr/src/motec/components/product/Card.vue').default,Spinner: require('/usr/src/motec/components/Spinner.vue').default,Error: require('/usr/src/motec/components/Error.vue').default})
